<!-- Tab图文信息展示列表：模块头+Tab按钮+图片+标题+内容 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <ul class="list-tab-ul" v-if="tabList.length>0">
      <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-li',tab.id==defaultTab ?'active' : '']" v-on:click="selectedAct(tab.id)">{{tab.title}}</li>
    </ul>
    <router-link :to="'/sggq'">更多</router-link>
  </div>
  <div class="info-list-content">
    <div class="list-container">
      <div class="list-container-cell" v-for="news in newsList" :style="{'width': celWidth}">
        <router-link :to="(defaultTab==1?'/sggq/qgDetail/2/':'/sggq/ghDetail/1/')+news.id" target="_blank">
          <div class="cell-base-info">
            <div class="base-info-title">{{news.name.length>titleLength?news.name.substring(0,14)+"...":news.name}}</div>
            <div class="base-info-label">{{news.description.length>40?news.description.substring(0,40)+"...":news.description}}</div>
            <div v-if="defaultTab==2" class="base-info-image" v-bind:style="{backgroundImage:'url(https://gyyg.oss-cn-shenzhen.aliyuncs.com'+news.image+')'}"></div>
          </div>
          <div class="cell-col-info">
            <table>
              <tr>
                <th>{{defaultTab==1?'计划采购':'计划销售'}}</th>
                <th v-if="defaultTab==2">价格</th>
                <th>截止时间</th>
              </tr>
              <tr>
                <td>{{news.supply_amount}}{{news.unit}}</td>
                <td v-if="defaultTab==2">{{news.price}}</td>
                <td>{{defaultTab==1?news.supply_date:news.expiry_date}}<span v-if="defaultTab==0">剩余三天</span></td>
              </tr>
            </table>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'InfoTabList01',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: Number,
      default: 12
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '6'
    }
  },
  data() {
    return {
      celWidth: "calc(100%/" + this.col + ")",
      // tabList:[{title:"供货信息",id:2},{title:"求购信息",id:1}],
      tabList:[],
      defaultTab:2,
      newsList: []
    }
  },
  methods:{
    selectedAct:function(id){
      this.defaultTab=id;
      this.queryPage();
    },
    queryPage:function(){
      let that=this;
      let params={page:1,pageSize:6};
      params.type=this.defaultTab;
      //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
      that.$dataApi.tradeLists(params).then(res =>{
          that.msg=res.msg;
          that.newsList=res.data.list;
          //
      });
    }
  },
  created:function(){
    this.queryPage();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.list-tab-ul {
  display:block;
  position:absolute;
  top:7px;
  left: 240px;
  heith:40px;
  list-style-type: none;
  padding: 0;
  //background:red;
}

.list-tab-li {
  float: left;
  margin: 0px 4px 0px 0px;
  height: 30px;
  width: 80px;
  color: #000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.list-tab-ul .active{
  color: #ffffff;
  background: var(--color7);
}


.list-container {
  display: flex;
  flex-wrap: wrap;
}

.list-container-cell {
  box-sizing: border-box;
  height: 170px;
  background: #fff;
  border: 0px solid red;
}

.list-container-cell a {
  display: block;
  box-sizing: border-box;
  padding:8px;
  margin:4px;
  background-color: #fff;
  border:1px solid #ddd;

}

.list-container-cell a:hover{
  border:1px solid orange;
  box-shadow:0px 0px 1px 0px orange;
}

.list-container-cell a:hover .base-info-title{
  color: var(--color6);
}

.list-container-cell .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  position:relative;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;

}

.cell-base-info .base-info-label{
  position:relative;
  height:40px;
  margin-right:75px;
  font-size:12px;
  line-height:20px;
  color:#888;

}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px 100%;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

.cell-col-info table{
  width:100%;
  height:50px;
  text-align:left;
}

.cell-col-info table th{
  font-size:12px;
  color:#eeeggg;
}

.cell-col-info table td{
  font-size:14px;
  color:#000;
}

.cell-col-info table td span{
  padding:1px 3px 1px 3px;
  margin-left:4px;
  font-size:12px;
  background:orange;
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/block/InfoTabList01.vue